const createFetchProxy = (sampleData, options) => {
  const handler = {
    apply() {
      const { successRate = 0.85, maxDelayInMillis = 1500 } = options ?? {};
      return new Promise((resolve, reject) => {
        const failureRate = Math.min(1, Math.max(0, 1 - successRate));
        const delayAmount = Math.floor(
          Math.random() * maxDelayInMillis
        );
        const wrapPayload = (payload) => ({
          json() {
            return new Promise((resolve2) => resolve2(payload));
          }
        });
        if (Math.random() > failureRate) {
          setTimeout(
            () => resolve(wrapPayload(sampleData)),
            delayAmount
          );
        } else {
          setTimeout(
            () => reject({
              errorCode: 500,
              errorMessage: "Fake server error."
            }),
            delayAmount
          );
        }
      });
    }
  };
  return new Proxy(fetch, (options == null ? void 0 : options.isNative) ? {} : handler);
};
const mergeModuleSettings = (data1, data2) => {
  const {
    composable_window = [],
    key_value = [],
    properties = [],
    ...defaultData
  } = data1 ?? {};
  const mergedData = defaultData;
  mergedData.composable_window = [
    ...composable_window,
    ...(data2 == null ? void 0 : data2.composable_window) ?? []
  ];
  mergedData.key_value = [
    ...key_value,
    ...(data2 == null ? void 0 : data2.key_value) ?? []
  ];
  mergedData.properties = [
    ...properties,
    ...(data2 == null ? void 0 : data2.properties) ?? []
  ];
  return mergedData;
};
const getStorageObject = (itemName, defaultValue = {}) => {
  if (typeof window === "undefined") return null;
  let _storageObjectValue;
  try {
    const item = localStorage == null ? void 0 : localStorage.getItem(itemName);
    _storageObjectValue = item ? JSON.parse(item) : defaultValue;
  } catch (err) {
    console.error(`Error retrieving storage object: ${err}`);
    _storageObjectValue = defaultValue;
  }
  const _storageObject = {
    get(propName) {
      return this[propName];
    },
    set(propName, value) {
      this[propName] = value;
      this.sync();
    },
    sync() {
      try {
        localStorage == null ? void 0 : localStorage.setItem(itemName, JSON.stringify(this));
      } catch (err) {
        console.error(`Error writing storage object: ${err}`);
      }
    }
  };
  Object.entries(_storageObjectValue).forEach(([key, value]) => {
    if (["get", "set", "sync"].includes(key)) return;
    _storageObject[key] = value;
  });
  return _storageObject;
};
const splitMarkdownLinks = (markdown = "") => {
  const startIndex = markdown.indexOf("{");
  const endIndex = markdown.lastIndexOf("}");
  if (startIndex === -1 || endIndex === -1) {
    return [markdown.trim()];
  }
  return [
    markdown.substring(0, startIndex).trim(),
    markdown.substring(startIndex + 1, endIndex),
    markdown.substring(endIndex + 1)
  ];
};
export {
  createFetchProxy,
  getStorageObject,
  mergeModuleSettings,
  splitMarkdownLinks
};
